import { useNavigate } from 'react-router-dom'
import { useWatchlist } from '../hooks/useFirestore'
import MovieCard from '../components/movie/MovieCard'
import Loader from '../components/common/Loader'
import './Watchlist.css'

function Watchlist() {
  const navigate = useNavigate()
  const { movies, loading, removeMovie } = useWatchlist()

  const handleRemove = async (e, movieId) => {
    e.stopPropagation()
    e.preventDefault()
    try {
      await removeMovie(movieId)
    } catch (err) {
      console.error('Error removing from watchlist:', err)
    }
  }

  if (loading) {
    return <Loader fullScreen />
  }

  return (
    <div className="page watchlist-page">
      <div className="container">
        <div className="page-header">
          <h1 className="page-title">🎯 Ver más tarde</h1>
          <p className="text-secondary">
            {movies.length} película{movies.length !== 1 ? 's' : ''} en tu lista
          </p>
        </div>

        {movies.length === 0 ? (
          <div className="empty-state">
            <div className="empty-state-icon">🎯</div>
            <p>Tu lista está vacía</p>
            <p className="text-sm text-muted">Busca películas y añádelas para ver después</p>
            <button 
              className="btn btn-primary"
              onClick={() => navigate('/search')}
              style={{ marginTop: 'var(--space-lg)' }}
            >
              Buscar películas
            </button>
          </div>
        ) : (
          <div className="watchlist-grid">
            {movies.map((movie) => (
              <div key={movie.id} className="watchlist-item">
                <MovieCard movie={movie} showWatchWith={true} />
                <button 
                  className="remove-btn"
                  onClick={(e) => handleRemove(e, movie.id)}
                  title="Quitar de la lista"
                >
                  ✕
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default Watchlist
